import { render, staticRenderFns } from "./CashDistribution.vue?vue&type=template&id=68433fc4&scoped=true&"
import script from "./CashDistribution.vue?vue&type=script&lang=js&"
export * from "./CashDistribution.vue?vue&type=script&lang=js&"
import style0 from "./CashDistribution.vue?vue&type=style&index=0&id=68433fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68433fc4",
  null
  
)

export default component.exports